/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Search_Preview_In_PlanInputs */

const en_us2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In your plan · ${i?.label}`)
};

const pt_br2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No seu plano · ${i?.label}`)
};

const es_419_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En tu plan · ${i?.label}`)
};

const pt_pt2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No teu plano · ${i?.label}`)
};

const fr_fr2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dans ton programme · ${i?.label}`)
};

const de_de2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In deinem Plan · ${i?.label}`)
};

const it_it2_search_preview_in_plan = /** @type {(inputs: Search_Preview_In_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nella tua scheda · ${i?.label}`)
};

/**
* | output |
* | --- |
* | "In your plan · {label}" |
*
* @param {Search_Preview_In_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_in_plan = /** @type {((inputs: Search_Preview_In_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_In_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_in_plan(inputs)
	if (locale === "es-419") return es_419_search_preview_in_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_in_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_in_plan(inputs)
	if (locale === "de-DE") return de_de2_search_preview_in_plan(inputs)
	if (locale === "it-IT") return it_it2_search_preview_in_plan(inputs)
	return en_us2_search_preview_in_plan(inputs)
});
export { search_preview_in_plan as "search.preview_in_plan" }